import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgBlueEyeDisabled = function SvgBlueEyeDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.769a2.771 2.771 0 1 0 0-5.542 2.771 2.771 0 0 0 0 5.542z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.724 8.231C15.594 5.657 12.369 3.18 9 3.18c-3.37 0-6.595 2.48-8.724 5.05a1.205 1.205 0 0 0 0 1.536c.535.646 1.657 1.895 3.156 2.986 3.774 2.747 7.354 2.753 11.136 0 1.499-1.091 2.62-2.34 3.156-2.986a1.205 1.205 0 0 0 0-1.536zM9 5.12c2.14 0 3.88 1.74 3.88 3.88 0 2.14-1.74 3.88-3.88 3.88-2.14 0-3.88-1.74-3.88-3.88 0-2.14 1.74-3.88 3.88-3.88z",
    fill: "#000"
  })));
};

export { SvgBlueEyeDisabled as ReactComponent };
//# sourceMappingURL=BlueEyeDisabled.svg.js.map
